import React from 'react'
import { Popover } from 'hljd'
import EmojiWrap from './emojiWrap'
import styles from './index.module.less'

const Emoji = props => {
  const insertEmoji = value => {
    let content = props.getFieldValue('content')
    content += value
    props.setFieldsValue({ content })
  }
  return (
    <div id="insert_img" className={styles.insertImg}>
      <Popover
        placement="bottomLeft"
        content={<EmojiWrap insertEmoji={insertEmoji} />}
        trigger="click"
        getPopupContainer={() => document.getElementById('insert_img')}
      >
        <button type="button" className={styles.emoji}>
          <span>表情</span>
        </button>
      </Popover>
    </div>
  )
}

export default Emoji
